import { connect } from 'react-redux';
import { toggleSideMenu, login, getProfile, searchTab, clearSearch } from './../../actions/globalActions';
import Header from './../../components/header/header';

const mapStateToProps = state => {
  return {
    sideMenuOpened: state.global.get('sideMenuOpened'),
    loginErrors: state.global.get('loginErrors'),
    profile: state.global.get('profile'),
    searchResults: state.global.get('searchResults'),
  };
};

const mapDispatchProps = dispatch => {
  return {
    toggleSideMenu: () => {
      dispatch(toggleSideMenu());
    },
    login: (user, pass) => {
      dispatch(login());
    },
    getProfile: () => {
      dispatch(getProfile());
    },
    searchTab: (term) => {
      dispatch(searchTab(term));
    },
    clearSearch: () => {
      dispatch(clearSearch());
    },
  }
};

const HeaderView = connect(mapStateToProps, mapDispatchProps)(Header);

export default HeaderView;



// WEBPACK FOOTER //
// ./src/views/headerView/headerView.js